import React from 'react';
import Formsy from 'formsy-react';
import Input from '../../form/FormsyInput';
import Checkbox from '../../form/Checkbox';
import ServiceModal from './ServiceModal';
import { onBoardingAPI } from '../../../InterfaceAPI/onboardingAPI';
import withOnboarding from '../withOnboarding';
import { maskPhone } from '../../../masks';
import MailChimp from '../../../helpers/mailchimp';

class ClientContact extends React.Component {
  defaultClient = {
    email: '',
    zip_code: '',
    phone_number: '',
    opt_in: false
  };

  state = {
    client: {
      ...this.defaultClient
    },
    modal: {
      isOpen: false,
      isServiceable: ''
    }
  };

  render() {
    // form elements must save state to top level state
    const { modal, content, client } = this.state;
    return (
      <div className="on-boarding__step on-boarding_step--client">
        <div className="on-boarding__wrap on-boarding__wrap--client-contact">
          <h1 className="on-boarding__h1">Let’s get started!</h1>
          <p className="on-boarding__p">
            We are currently serving New York City, the Hamptons and Los Angeles
            for our weekly service. Enter your information below to get started.
            If you’re not in these areas, enter your information and we'll be in
            touch.
          </p>
          <Formsy
            className="form on-boarding__contact-form"
            onValidSubmit={this.handleSubmit}
            onInvalidSubmit={this.handleInvalidSubmit}
            onValid={this.handleValid}
            onInvalid={this.handleInvalid}
          >
            <div className="form__row">
              <div className="form__row-item form__row-item--half">
                <Input
                  name="email"
                  type="email"
                  value={client.email}
                  onChange={this.handleChange}
                  placeholder="Email"
                  validations="isEmail"
                  required
                />
              </div>
              <div className="form__row-item form__row-item--half">
                <Input
                  name="phone_number"
                  type="num"
                  value={client.phone_number}
                  onChange={this.handleChange}
                  placeholder="Phone Number"
                  mask={maskPhone}
                  required
                />
              </div>
            </div>

            <div className="form__row">
              <div className="form__row-item form__row-item--half">
                <Input
                  name="zip_code"
                  type="num"
                  value={client.zip_code}
                  onChange={this.handleChange}
                  placeholder="Zip"
                  required
                />
              </div>
            </div>
            <div className="form__row">
              <div className="form__row-item">
                <Checkbox
                  name="opt_in"
                  checked={client.opt_in}
                  placeholder="Opt in to receive weekly menus, culinary advice, tips, and tricks from The Culinistas"
                  className="checkbox--small checkbox--green checkbox--inline checkbox--wrap"
                  onChange={this.handleChange}
                />
              </div>
            </div>
            <Input
              type="hidden"
              name="all_forms_valid"
              value={this.props.actions.isValid('submit')}
              validations="isTrue"
            />

            <input
              ref={this.props.actions.assignTrigger}
              type="submit"
              hidden
            />
          </Formsy>

          <ServiceModal
            content={content}
            modal={modal}
            closeModal={this.closeModal}
            postMaybeSignup={this.postMaybeSignup}
            client={this.state.client}
          />
        </div>
      </div>
    );
  }

  handleChange = e => {
    const value =
      e.target.type === 'checkbox' ? e.target.checked : e.target.value;
    this.setState({ client: { ...this.state.client, [e.target.name]: value } });
  };

  handleInvalidSubmit = () => console.log('failed submit');

  handleValid = () => this.props.actions.setValidState('main', true);
  handleInvalid = () => this.props.actions.setValidState('main', false);

  // this will be triggered from the ClientOnboarding component
  handleSubmit = e => {
    // Subscribe to MailChimp Master List if Opt In Selected
    if (this.state.client.opt_in === true) {
      // Subscribe to Soft Launch
      MailChimp.subscribe(this.state.client.email, 'SOFT_LAUNCH');
    }

    // Subscribe Everyone to the Transactional List
    MailChimp.subscribe(this.state.client.email, 'TRANSACTIONAL');

    // 10010 - yes
    // 07020 - maybe
    // 00000 - no
    onBoardingAPI
      .isServiceable(this.state.client.zip_code)
      .then(data => {
        const { serviceability_status } = data.data;
        if (serviceability_status === 'SERVICEABLE') this.go();
        else if (serviceability_status === 'MAYBE_SERVICEABLE') {
          this.openModal('maybe');
        } else this.openModal('no');
      })
      .catch(err => console.error('error:', err)); // todo: error handling
  };

  // proceeds to next step
  go() {
    const client = {
      email: this.state.client.email,
      phone_number: this.state.client.phone_number,
      service_addresses: [
        {
          zip_code: this.state.client.zip_code
        }
      ]
    };
    // update client
    this.props.updateClient(client);
    this.props.actions.markComplete(this.props.step);
  }

  openModal = isServiceable => {
    const modal = {
      isOpen: true,
      isServiceable
    };
    this.setState({ modal });
  };

  closeModal = () => {
    const modal = {
      isOpen: false,
      isServiceable: ''
    };
    this.setState({ modal });
  };

  postMaybeSignup = (contactType, callback) => {
    const { email, phone_number, zip_code } = this.state.client;
    const maybe_serviceable_client = {
      email,
      phone: phone_number,
      zip: zip_code,
      contact_preference: contactType
    };

    onBoardingAPI
      .maybeServiceable(maybe_serviceable_client)
      .then(data => {
        console.log('success' + data);
        callback();
      })
      .catch(err => console.error('error:', err));
  };

  initState(prevProps = {}) {
    // init client state from props
    if (this.props.client !== prevProps.client) {
      const service_addresses = this.props.client.service_addresses || [];
      const client = {
        ...this.defaultClient,
        email: this.props.client.email || '',
        phone_number: this.props.client.phone_number || ''
      };

      if (service_addresses.length > 0) {
        client.zip_code =
          'zip_code' in service_addresses[0]
            ? service_addresses[0].zip_code
            : '';
      }

      this.setState({ client });
    }
  }

  componentWillMount() {
    this.initState();
  }

  componentDidUpdate(prevProps, nextState) {
    this.initState(prevProps);
  }
}

export default withOnboarding(ClientContact);



// WEBPACK FOOTER //
// ./src/components/onboarding/client/ClientContact.js